import * as React from 'react';
import { cn } from '../../../../lib/utils';
import { LightSwitchProps } from './interface';
import { indicatorStyle, rockerStyle } from './utils';

const LightSwitch = React.forwardRef<HTMLButtonElement, LightSwitchProps>(
  ({ checked, onCheckedChange, className, ...props }, ref) => (
    <button
      ref={ref}
      type="button"
      role="switch"
      aria-checked={checked}
      onClick={() => onCheckedChange(!checked)}
      className={cn(
        'group relative h-7 w-10 shrink-0 rounded-md border border-slate-200 bg-gradient-to-b from-white to-slate-100 p-1.5',
        'shadow-[0_1px_2px_rgba(15,23,42,0.15),inset_0_1px_0_white]',
        'dark:border-slate-700 dark:from-slate-700 dark:to-slate-800 dark:shadow-[0_1px_2px_rgba(0,0,0,0.5),inset_0_1px_0_rgba(255,255,255,0.08)]',
        'focus:outline-none focus-visible:ring-2 focus-visible:ring-[#459fec] focus-visible:ring-offset-2 dark:focus-visible:ring-offset-slate-900',
        className,
      )}
      {...props}
    >
      {/* Recess in the wall plate */}
      <span
        className="relative block h-full w-full rounded-[4px] bg-slate-300 shadow-[inset_0_1px_3px_rgba(15,23,42,0.35)] dark:bg-slate-950"
        style={{ perspective: '60px' }}
      >
        {/* Rocker */}
        <span
          className={cn(
            'absolute inset-0 rounded-[4px] bg-gradient-to-r transition-transform duration-200 ease-out motion-reduce:transition-none',
            'group-active:scale-95',
            checked
              ? 'from-white to-slate-200 dark:from-slate-500 dark:to-slate-700'
              : 'from-slate-200 to-white dark:from-slate-700 dark:to-slate-500',
          )}
          style={rockerStyle(checked)}
        >
          <span className="absolute inset-y-0.5 left-1/2 w-px -translate-x-1/2 bg-slate-300/70 dark:bg-slate-800/70" />
          <span
            className={cn(
              'absolute top-1/2 h-2 w-1 -translate-y-1/2 rounded-full bg-slate-300 transition-all duration-200 dark:bg-slate-800',
              checked ? 'right-1' : 'left-1',
            )}
            style={indicatorStyle(checked)}
          />
        </span>
      </span>
    </button>
  ),
);
LightSwitch.displayName = 'LightSwitch';

export default LightSwitch;
export type { LightSwitchProps };
